import * as React from 'react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { AutomationsListComponent } from 'modules/automations/components/AutomationsListComponent'
import { useAutomationContextlessPolicies } from 'modules/automations/hooks/useAutomationContextlessPolicies'
import { InsertAutomationProvider } from 'modules/automations/lib/automationContext'

const AuthorizedAutomationsListPage = () => {
  const { manageCustomNotifications } = useAutomationContextlessPolicies()
  return (
    <AuthorizeUser authorizeFn={() => manageCustomNotifications}>
      <InsertAutomationProvider>
        <AutomationsListComponent />
      </InsertAutomationProvider>
    </AuthorizeUser>
  )
}

export default AuthorizedAutomationsListPage
